import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom'
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import BannerImage from '../assets/Space.jpg'
import Moment from 'moment';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import './submission.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import SubCardWall from '../card/walls/submission.js'
import SubSoldWall from '../card/walls/subSold.js'
import SubUnsoldWall from '../card/walls/subUnsold.js'

function Submission() {
  const { id } = useParams()
  const [subData, setSubData] = useState<Record<string, any>>({});
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [data, setData] = useState([]);
  const [key, setKey] = useState('cardWall');

  function formatCurrency(value: number | null | undefined) {
    return typeof value === 'number'
      ? value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      : '$0.00';
  }

  function parseCoverImage(value: unknown) {
    if (!value) {
      return 'http://alientrader.net/cards/cards/images/cards/Temp.jpg';
    }

    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      const thumbnail = Array.isArray(parsed) ? parsed[0]?.thumbnail : undefined;

      if (!thumbnail || thumbnail === 'none') {
        return 'http://alientrader.net/cards/cards/images/cards/Temp.jpg';
      }

      if (thumbnail.includes('/home/u825454141/domains/alientrader.net/public_html/')) {
        return thumbnail.replace('/home/u825454141/domains/alientrader.net/public_html/', 'http://alientrader.net/');
      }

      return `https://api.alientrader.cards/${thumbnail}`;
    } catch (error) {
      console.error('Error parsing cover image:', error);
      return 'http://alientrader.net/cards/cards/images/cards/Temp.jpg';
    }
  }

  const columns: GridColDef[] = [
    {
      field: 'card_grade_sub_order',
      headerName: 'Order',
      width: 40,
      align: 'center'
    },
    {
      field: 'card_sold_price',
      headerName: 'Sold Price',
      width: 70,
      align: 'right',
      renderCell: (params) => {
        if (typeof params.value !== 'number') {
          return '-';
        }
        return `$${params.value.toFixed(2)}`;
      },
    },
    {
      field: 'cover_image',
      headerName: 'Card',
      width: 90,
      align: 'center',
      renderCell: (params) => {
        const imageUrl = parseCoverImage(params.value);
        const cardId = params.row.card_id;

        return (
          <div>
            <Link to={`/card/${cardId}`}>
              <img src={imageUrl} alt="card" style={{ height: '100px', borderRadius: '5px' }} />
            </Link>
          </div>
        );
      }
    },
    {
      field: 'card_pokemon',
      headerName: 'Pokemon',
      width: 90,
      renderCell: (params) => {
        const cardId = params.row.card_id;

        return (
          <Link to={`/card/${cardId}`}>
            {params.value}
          </Link>
        );
      }
    },
    {
      field: 'card_grade_number',
      headerName: 'Grade #',
      width: 60,
    },
    {
      field: 'card_grade',
      headerName: 'Grade',
      width: 70,
    },
    {
      field: 'card',
      headerName: 'Variety / Pedigree:',
      width: 120,
    },
    {
      field: 'card_set_year',
      headerName: 'Year:',
      width: 50,
    },
    {
      field: 'card_set',
      headerName: 'Set:',
      width: 150,
    },
    {
      field: 'card_language',
      headerName: 'Language:',
      width: 70,
    },
    {
      field: 'card_price',
      headerName: 'Price:',
      width: 65,
      renderCell: (params) => {
        return formatCurrency(typeof params.value === 'number' ? params.value : null);
      }
    },
    {
      field: 'card_fee_grade',
      headerName: 'Grade Fee:',
      width: 75,
      renderCell: (params) => {
        return formatCurrency(typeof params.value === 'number' ? params.value : null);
      }
    },
    {
      field: 'card_fee_shiptax',
      headerName: 'Ship & Tax:',
      width: 75,
      renderCell: (params) => {
        return formatCurrency(typeof params.value === 'number' ? params.value : null);
      }
    },
    {
      field: 'card_total_cost',
      headerName: 'Total Cost:',
      width: 70,
      renderCell: (params) => {
        return formatCurrency(typeof params.value === 'number' ? params.value : null);
      }
    },
    {
      field: 'card_date_received',
      headerName: 'Received Date:',
      width: 80,
      align: 'right',
      renderCell: (params) => {
        const value = params.value;
        if (!value) return '-';

        const str = String(value);
        const datePart = str.split('T')[0]; // "YYYY-MM-DD"
        const [y, m, d] = datePart.split('-').map(Number);

        // Build a local Date for that Y/M/D without going through UTC midnight
        const date = new Date(y, m - 1, d);
        return date.toLocaleDateString();
      }
    },
    {
      field: 'card_owner',
      headerName: 'Owner:',
      width: 85,
    },
  ];

  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}`)
      .then((response) => {
        setSubData(response.data[0]);
      })
      .catch(error => {
        console.error('Error fetching card data:', error);
      });
  }, [id])
  // Treat backend dates as date-only, ignoring timezone
  const toMomentDate = (value: any) => {
    if (!value) return null;

    // Handle "YYYY-MM-DD" or full ISO "YYYY-MM-DDTHH:MM:SSZ"
    const str = String(value);
    const datePart = str.split('T')[0]; // e.g. "2025-12-03"

    // Use UTC so there is zero local offset
    return Moment.utc(datePart, 'YYYY-MM-DD');
  };

  const formatDisplayDate = (value: any) => {
    const m = toMomentDate(value);
    return m ? m.format('MM-DD-YYYY') : '-';
  };
  const subDateMoment = toMomentDate(subData.sub_date);
  const subReturnDateMoment = toMomentDate(subData.sub_return_date);

  // Calculate the difference in days (no timezone issues)
  const subTurnaround =
    subReturnDateMoment && subDateMoment
      ? subReturnDateMoment.diff(subDateMoment, 'days')
      : '-';

  // Format dates for display
  const subDate = formatDisplayDate(subData.sub_date);
  const subReturnDate = formatDisplayDate(subData.sub_return_date);
  const subPreCost = formatCurrency(subData.sub_precost);
  const subShippingTo = formatCurrency(subData.sub_shipping_to);
  const subShippingFrom = formatCurrency(subData.sub_shipping_from);
  const subUpcharge = formatCurrency(subData.sub_upcharge);
  const subTotalCost = formatCurrency(subData.sub_total_cost);
  const subPSAorderArrived = formatDisplayDate(subData.PSA_Order_Arrived);
  const subPSAorderPrep = formatDisplayDate(subData.PSA_Order_Prep);
  const subPSAresearchID = formatDisplayDate(subData.PSA_Research_ID);
  const subPSAgrading = formatDisplayDate(subData.PSA_Grading);
  const subPSAassembly = formatDisplayDate(subData.PSA_Assembly);
  const subPSAgradesReady = formatDisplayDate(subData.PSA_Grades_Ready);
  const subPSAqaChecks = formatDisplayDate(subData.PSA_QA_Checks);
  const subPSACompleted = formatDisplayDate(subData.PSA_Completed);


  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/cards/${id}`)
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [id]);

  const [soldPriceData, setSoldPriceData] = useState<number | null>(null);
  const soldPrice = formatCurrency(soldPriceData);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/sold/card_sold_price`)
      .then((response) => {
        setSoldPriceData(response.data[0]?.TotalSoldPrice ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [soldFees, setSoldFees] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/sold/card_sold_fees`)
      .then((response) => {
        setSoldFees(response.data[0]?.SubSoldFees ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [soldShip, setSoldShip] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/sold/card_solds_ship`)
      .then((response) => {
        setSoldShip(response.data[0]?.SubSoldShip ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const netSalesCalc =
    soldPriceData !== null && soldFees !== null && soldShip !== null
      ? soldPriceData - soldFees - soldShip
      : null;
  const netSales = formatCurrency(netSalesCalc);
  const [soldCount, setSoldCount] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/sold/count`)
      .then((response) => {
        setSoldCount(response.data[0]?.TotalSoldCount ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [soldProfitData, setSoldProfitData] = useState<number | null>(null);
  const soldProfit = formatCurrency(soldProfitData);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/sold/card_profit`)
      .then((response) => {
        setSoldProfitData(response.data[0]?.TotalSoldProfit ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardCostData, setCardCostData] = useState<number | null>(null);
  const cardCost = formatCurrency(cardCostData);
  const breakevenCalc =
    netSalesCalc !== null && cardCostData !== null
      ? netSalesCalc - cardCostData
      : null;
  const breakeven = formatCurrency(breakevenCalc);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/card/card_total_cost`)
      .then((response) => {
        setCardCostData(response.data[0]?.TotalCost ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade10, setCardGrade10] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/10`)
      .then((response) => {
        setCardGrade10(response.data[0]?.TotalGrade10 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade95, setCardGrade95] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/9-5`)
      .then((response) => {
        setCardGrade95(response.data[0]?.TotalGrade95 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade9, setCardGrade9] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/9`)
      .then((response) => {
        setCardGrade9(response.data[0]?.TotalGrade9 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade85, setCardGrade85] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/8-5`)
      .then((response) => {
        setCardGrade85(response.data[0]?.TotalGrade85 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade8, setCardGrade8] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/8`)
      .then((response) => {
        setCardGrade8(response.data[0]?.TotalGrade8 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade75, setCardGrade75] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/7-5`)
      .then((response) => {
        setCardGrade75(response.data[0]?.TotalGrade75 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade7, setCardGrade7] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/7`)
      .then((response) => {
        setCardGrade7(response.data[0]?.TotalGrade7 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);
  const [cardGrade6, setCardGrade6] = useState<number | null>(null);
  useEffect(() => {
    axios.get(`https://api.alientrader.cards/submission/${id}/grade/6`)
      .then((response) => {
        setCardGrade6(response.data[0]?.TotalGrade6 ?? null);
      })
      .catch((error) => {
        console.error(`Error fetching data: ${error}`);
      });
  }, [id]);

  return (
    <div>
      <div className='subTopBG' style={{ backgroundImage: `url(${BannerImage})` }}>
        <div className='actions'>
          <div className='goBack' onClick={goBack}><ArrowBackIcon fontSize="large" /></div>
          <div className='cardViewEdit'><Link to={`/dashboard/submissions/${subData.sub_id}/edit`}><EditIcon fontSize="large" /></Link></div>
        </div>
        <div className='subHeader'>{subData.sub_text}</div>
        <div><br /></div>
      </div>
      <div className='actions'>
      </div>
      <div className='subBox'>
        <Container>
          <Row className='d-flex justify-content-center'>
            <Col xs="9" sm="5" lg="5" xl="3" className='custom-info-box shadow-sm'>
              <Row><div className='custom-info-header'>Submission Info</div></Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Grading Company:</div></Col>
                <Col><div className='custom-info-val'>{subData.sub_grader}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Order Number:</div></Col>
                <Col><div className='custom-info-val'>{subData.sub_order_number}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Number of Cards:</div></Col>
                <Col><div className='custom-info-val'>{subData.sub_total_cards}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Submitted Date:</div></Col>
                <Col><div className='custom-info-val'>{subDate}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Returned Date:</div></Col>
                <Col><div className='custom-info-val'>{subReturnDate}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Turnaround:</div></Col>
                <Col><div className='custom-info-val'>{typeof subTurnaround === 'number' ? `${subTurnaround} Days` : '-'}</div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
            <Col xs="9" sm="5" lg="3" xl="2" className='custom-info-box shadow-sm'>
              <Row><div className='custom-info-header'>Grades</div></Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>GEM MINT - 10:</div></Col>
                <Col xs={2} sm={2}><div className='custom-info-val'>{cardGrade10 ?? '-'}</div></Col>
                <Col xs={4} sm={4}><div className='custom-info-val'></div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>MT - 9:</div></Col>
                <Col xs={2} sm={2}><div className='custom-info-val'>{cardGrade9 ?? '-'}</div></Col>
                <Col xs={1} sm={1}><div className='custom-info-title'>9.5+</div></Col>
                <Col xs={3} sm={3}><div className='custom-info-val'>{cardGrade95 ?? '-'}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>NM-MT - 8:</div></Col>
                <Col xs={2} sm={2}><div className='custom-info-val'>{cardGrade8 ?? '-'}</div></Col>
                <Col xs={1} sm={1}><div className='custom-info-title'>8.5+</div></Col>
                <Col xs={3} sm={3}><div className='custom-info-val'>{cardGrade85 ?? '-'}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>NM - 7:</div></Col>
                <Col xs={2} sm={2}><div className='custom-info-val'>{cardGrade7 ?? '-'}</div></Col>
                <Col xs={1} sm={1}><div className='custom-info-title'>7.5+</div></Col>
                <Col xs={3} sm={3}><div className='custom-info-val'>{cardGrade75 ?? '-'}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Below 7:</div></Col>
                <Col xs={2} sm={2}><div className='custom-info-val'>{cardGrade6 ?? '-'}</div></Col>
                <Col xs={4} sm={4}><div className='custom-info-val'></div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
            <Col xs="9" sm="5" lg="5" xl="3" className='custom-info-box shadow-sm'>
              <Row><div className='custom-info-header'>Submission Expense</div></Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Submission Cost:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{subPreCost}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Shipping to:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{subShippingTo}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Shipping from:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{subShippingFrom}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Upcharge Cost:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{subUpcharge}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Total Grading Cost:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{subTotalCost}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Total Card Costs:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{cardCost}</div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
            <Col xs="9" sm="5" lg="3" xl="2" className='custom-info-box shadow-sm'>
              <Row><div className='custom-info-header'>Sold Info</div></Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'># of Sold:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{soldCount ?? '-'}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Total Sales:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{soldPrice}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Net Sales - Fees:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{netSales}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Profit on Cards Sold:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{soldProfit}</div></Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center'>
                <Col><div className='custom-info-title'>Breakeven:</div></Col>
                <Col xs={5} sm={5}><div className='custom-info-val'>{breakeven}</div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
          </Row>
        </Container>
      </div>
      <div className='subPositionAdjust'>
        <Container>
          <Row className='d-flex align-items-center justify-content-center'>
            <Col lg={8} className='custom-info-box shadow-sm'>
              <Row>
                <Tabs id="card-information" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                  <Tab eventKey="cardWall" title="Card Wall">
                    <Row className='subCardWall d-flex align-items-center justify-content-center'>
                      <SubCardWall />
                    </Row>
                  </Tab>
                  <Tab eventKey="soldWall" title="Sold">
                    <Row className='subCardWall d-flex align-items-center justify-content-center'>
                      <SubSoldWall />
                    </Row>
                  </Tab>
                  <Tab eventKey="unsoldWall" title="Unsold">
                    <Row className='subCardWall d-flex align-items-center justify-content-center'>
                      <SubUnsoldWall />
                    </Row>
                  </Tab>
                  {subData && subData.sub_grader === "PSA" && (<Tab eventKey="psa-dates" title="Dates">
                    <Row className='subCardWall d-flex align-items-center justify-content-center'>
                      <Row><div className='custom-info-header'>PSA Date Info</div></Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Order Arrived:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAorderArrived}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Order Prep:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAorderPrep}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Research & ID:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAresearchID}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Grading:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAgrading}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Assembly:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAassembly}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Grades Ready:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAgradesReady}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>QA Checks:</div></Col>
                        <Col><div className='subGraderDates'>{subPSAqaChecks}</div></Col>
                      </Row>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col><div className='custom-info-title'>Completed:</div></Col>
                        <Col><div className='subGraderDates'>{subPSACompleted}</div></Col>
                      </Row>
                      <Row><br /></Row>
                    </Row>
                  </Tab>)}
                  {subData && subData.sub_notes && (<Tab eventKey="notes" title="Notes">
                    <Row className='subCardWall d-flex align-items-center justify-content-center'>
                      <Row className='d-flex align-items-center justify-content-center'>
                        <Col xs={2} sm={2}><div className='custom-info-title'>Notes:</div></Col>
                        <Col><div className='custom-info-misc'>{subData.sub_notes}</div></Col>
                      </Row>
                      <Row><br /></Row>
                    </Row>
                  </Tab>)}
                </Tabs>
              </Row>
            </Col>
          </Row>
          <Row><br /></Row>
          <Row className='d-flex align-items-center justify-content-center'>
            <Col className='d-flex align-items-center justify-content-center'>
              <div style={{ height: 800, width: '100%' }}>
                <DataGrid
                  rows={data}
                  columns={columns}
                  getRowId={(row) => row.card_id}
                  rowHeight={110}
                  sx={{
                    fontSize: 10,
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Submission;
